// Import utilities
import { onReady } from '@automator/utilities';

// Load global assets
import '@pages/global';

import './settings';

// Page "Dashboard"
import Dashboard from '@pages/dashboard';

// Page "Integrations"
import Integrations from '@pages/integrations';

// Page "Logs" (deprecated)
import '@pages/logs';

// Page "Logs" (new)
import '@pages/new-logs';

// Page "Setup wizard"
import '@pages/setup-wizard';

// Page "Upgrade"
import '@pages/upgrade-upsell';

// Invoke classes when the DOM is ready
onReady( () => {
	new Dashboard();
	new Integrations();
} );
